import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"


export enum FilterDataModule {
  RandomModule = 6
}
export enum FilterCriteriaCode {
  Company = 2,
  Location = 4,
  RegulatoryMode = 12,
  Unknown = 0
}
export enum FilterSaveResult {
  SuccessfullySaved = 0,
  SaveError = 1,
  Duplicate = 2
}

export const EmptyPoolCriteria: PoolCriteria = {
  PoolID: 0,
  ImplementationID: 0,
  FilterModuleID: FilterDataModule.RandomModule,
  FilterDataID: 0,
  SaveAs: "",
  ForceOverride: false,
  IsFilter: false,
  UserName: "",
  UserLoginID: 0,
  SaveResultCode: FilterSaveResult.SuccessfullySaved,
  SaveResultText: "",
  Items: [],
  IsConsortium: false
}

export const EmptyPoolCriteriaItem: PoolCriteriaItem = {
  FilterCriteriaID: 0,
  FilterCriteriaName: "Unknown",
  Name: "",
  Values: []
}

export default interface PoolCriteria {
  PoolID: number
  ImplementationID: number
  FilterModuleID: number
  FilterDataID: number
  SaveAs: string
  ForceOverride: boolean
  IsFilter: boolean
  UserName: string
  UserLoginID: number
  SaveResultCode: FilterSaveResult
  SaveResultText: string
  Items: PoolCriteriaItem[]
  IsConsortium: boolean
}

export interface PoolCriteriaItem {
  FilterCriteriaID: number
  FilterCriteriaName: string
  Name: string
  Values: PoolCriteriaValue[]
}

export interface PoolCriteriaValue {
  ID: number
  IntValue: number
  StringValue: string
  BoolValue: boolean
  StringValue2?: string
  StringValue3?: string
}


export const EmptyFilterData: FilterData = {
  FilterDataID: 0,
  ImplementationID: 0,
  FilterModuleID: 0,
  Name: "",
  ForceOverride: true,
  UserName: "",
  UserLoginID: 0,
  SaveResultCode: FilterSaveResult.SuccessfullySaved,
  SaveResultText: "",
  Items: []
}

export const EmptyFilterDataItem: FilterDataItem = {
  FilterCriteriaID: 0,
  FilterCriteriaName: "Unknown",
  Name: "",
  Values: []
}

export interface FilterDataName {
  FilterDataID: number
  Name: string
}

export interface FilterData {
  FilterDataID: number
  ImplementationID: number
  FilterModuleID: number
  Name: string
  ForceOverride: boolean
  UserName: string
  UserLoginID: number
  SaveResultCode: FilterSaveResult
  SaveResultText: string
  Items: FilterDataItem[]
}

export interface FilterDataItem {

  FilterCriteriaID: number
  FilterCriteriaName: string
  Name: string
  Values: FilterDataValue[]
}

export interface FilterDataValue {
  ID: number
  IntValue: number
  StringValue: string
  BoolValue: boolean
}

export function CopyFilterDataName(src: FilterDataName): FilterDataName {
  const result: FilterDataName = {
    FilterDataID: src.FilterDataID,
    Name: src.Name
  }
  return result
}
export function CopyFilterDataNames(src: FilterDataName[]): FilterDataName[] {
  const result: FilterDataName[] = []
  for (let i = 0; i < src.length; i++) {
    const item = CopyFilterDataName(src[i])
    result.push(item)
  }
  
  return result
}

export function GetPoolCriteriaItemByCode(criteria: PoolCriteria, code: FilterCriteriaCode, add: boolean = false): PoolCriteriaItem {
  if (!criteria) {
    return { ...EmptyPoolCriteriaItem }
  }
  const items = criteria.Items
  const result = items.find(item => item.FilterCriteriaID === code)
  if (add && !result) {
    const newItem = { ...EmptyPoolCriteriaItem, FilterCriteriaID: code }
    items.push(newItem)
    return newItem
  }
  return result || { ...EmptyPoolCriteriaItem }
}

export function GetCompanyPoolCriteriaItem(criteria: PoolCriteria): PoolCriteriaItem {
  let result = GetPoolCriteriaItemByCode(criteria, FilterCriteriaCode.Company)
  return result
}
export function GetRegulatoryModePoolCriteriaItem(criteria: PoolCriteria): PoolCriteriaItem {
  let result = GetPoolCriteriaItemByCode(criteria, FilterCriteriaCode.RegulatoryMode)
  return result
}

export function GetPoolCriteriaItemStringValues(item?: PoolCriteriaItem) {
  return item?.Values.map(val => val.StringValue) || []
}

export function GetFilterDataNameIndexByID(items: FilterDataName[], filterDataId: number): number {
  if (!items) {
    return -1;
  }
  const result = items.findIndex(item => item.FilterDataID === filterDataId);
  return result;
}

export function CreateEmptyPoolCriteria(poolId: number): PoolCriteria {
  const result: PoolCriteria = {
    PoolID: poolId,
    ImplementationID: 0,
    FilterModuleID: FilterDataModule.RandomModule,
    FilterDataID: 0,
    SaveAs: "",
    ForceOverride: false,
    IsFilter: false,
    UserName: "",
    UserLoginID: 0,
    SaveResultCode: FilterSaveResult.SuccessfullySaved,
    SaveResultText: "",
    Items: [],
    IsConsortium: false
  }
  return result;
}
export function CreateEmptyPoolCriteriaItem(): PoolCriteriaItem {
  const result: PoolCriteriaItem = {
    FilterCriteriaID: 0,
    FilterCriteriaName: "",
    Name: "",
    Values: []
  }
  return result;
}
export function FilterDataToPoolCriteria(poolId: number, filterData: FilterData, skipCompany: boolean = false): PoolCriteria {

  let result: PoolCriteria = CreateEmptyPoolCriteria(poolId);
  result.ImplementationID = filterData.ImplementationID;
  result.FilterModuleID = filterData.FilterModuleID
  result.FilterDataID = filterData.FilterDataID;
  result.SaveAs = filterData.Name;
  result.IsFilter = true;
  for (let i = 0; i < filterData.Items.length; i++) {
    const filterDataItem: FilterDataItem = filterData.Items[i];
    if (skipCompany && filterDataItem.FilterCriteriaID === FilterCriteriaCode.Company) {
      continue
    }
    const poolCriteriaItem: PoolCriteriaItem = FilterDataItemToPoolCriteriaItem(filterDataItem)
    result.Items.push(poolCriteriaItem)
  }
  return result;
}

export function FilterDataItemToPoolCriteriaItem(filterDataItem: FilterDataItem): PoolCriteriaItem {
  let result: PoolCriteriaItem = CreateEmptyPoolCriteriaItem();
  result.FilterCriteriaID = filterDataItem.FilterCriteriaID;
  result.FilterCriteriaName = filterDataItem.FilterCriteriaName;
  result.Name = filterDataItem.Name;
  for (let i = 0; i < filterDataItem.Values.length; i++) {
    const filterDataValue: FilterDataValue = filterDataItem.Values[i];
    const poolCriteriaValue: PoolCriteriaValue = FilterDataValueToPoolCriteriaValue(filterDataValue);
    result.Values.push(poolCriteriaValue);
  }
  return result
}

export function FilterDataValueToPoolCriteriaValue(src: FilterDataValue): PoolCriteriaValue {
  const result: PoolCriteriaValue = {
    ID: src.ID,
    IntValue: src.IntValue,
    StringValue: src.StringValue,
    StringValue2: "",
    StringValue3: "",
    BoolValue: src.BoolValue
  }
  return result
}

export function CopyPoolCriteriaValue(src: PoolCriteriaValue):PoolCriteriaValue
{
  const result: PoolCriteriaValue = {
    ID: src.ID,
    IntValue: src.IntValue,
    StringValue: src.StringValue,
    StringValue2: src.StringValue2 || "",
    StringValue3: src.StringValue3 || "",
    BoolValue: src.BoolValue
  }
  return result
}

export function CopyPoolCriteriaValues(src: PoolCriteriaValue[]):PoolCriteriaValue[]
{
  const result: PoolCriteriaValue[] = []
  for (let i = 0; i < src.length; i++) {
    const item = CopyPoolCriteriaValue(src[i])
    result.push(item)
  }
  return result
}
export function CopyPoolCriteriaItem(src: PoolCriteriaItem): PoolCriteriaItem {
  const result: PoolCriteriaItem = CreateEmptyPoolCriteriaItem();
  result.FilterCriteriaID = src.FilterCriteriaID;
  result.FilterCriteriaName = src.FilterCriteriaName;
  result.Name = src.Name;
  result.Values = CopyPoolCriteriaValues(src.Values)
  return result
}
export function CopyPoolCriteriaItems(src: PoolCriteriaItem[]): PoolCriteriaItem[] {
  const result: PoolCriteriaItem[] = []
  for (let i = 0; i < src.length; i++) {
    const item = CopyPoolCriteriaItem(src[i])
    result.push(item)
  }
  return result
}
export function CopyPoolCriteria(src: PoolCriteria): PoolCriteria {
  const result: PoolCriteria = CreateEmptyPoolCriteria(src.PoolID);
  result.ImplementationID = src.ImplementationID;
  result.FilterModuleID = src.FilterModuleID;
  result.FilterDataID = src.FilterDataID;
  result.SaveAs = src.SaveAs;
  result.ForceOverride = src.ForceOverride;
  result.IsFilter = src.IsFilter;
  result.UserName = src.UserName;
  result.UserLoginID = src.UserLoginID;
  result.SaveResultCode = src.SaveResultCode;
  result.SaveResultText = src.SaveResultText;
  result.Items = CopyPoolCriteriaItems(src.Items)

  return result

}

export interface GetPoolCriteriaParams {
  PoolID: number
  ImplementationID: number
  FilterModuleID: number
  UserName: string
  UserLoginID: number
}

export interface GetSavedQueriesParams {
  ImplementationID: number
  FilterModuleID: number
}
export interface GetSavedQueryParams {
  FilterDataID: number
  Name: string
  ImplementationID: number
  FilterModuleID: number
  UserName: string
  UserLoginID: number
}
export interface DeleteSavedQueryParams {
  FilterDataID: number
}

export function GetPoolCriteria(poolId: number): Observable<PoolCriteria> {
  const params: string = JSON.stringify({
    PoolID: poolId,
    ImplementationID: 0,
    FilterModuleID: FilterDataModule.RandomModule,
    UserName: "",
    UserLoginID: 0
  })
  return ObservableFromFetch<PoolCriteria>("RandomTest/GetPoolCriteria", params)
}

export function SavePoolCriteria(poolCriteria: PoolCriteria): Observable<PoolCriteria> {
  const params: string = JSON.stringify(poolCriteria)
  return ObservableFromFetch<PoolCriteria>("RandomTest/SavePoolCriteria", params)
}

export function GetSavedQueries(implementationID: number): Observable<FilterDataName[]> {
  const params: string = JSON.stringify({
    ImplementationID: implementationID,
    FilterModuleID: FilterDataModule.RandomModule
  })
  return ObservableFromFetch<FilterDataName[]>("RandomTest/GetSavedQueries", params)
}

export function GetSavedQuery(filterDataID: number, name: string): Observable<FilterData> {
  const params: string = JSON.stringify({
    FilterDataID: filterDataID,
    Name: name,
    ImplementationID: 0,
    FilterModuleID: FilterDataModule.RandomModule,
    UserName: "",
    UserLoginID: 0
  })
  return ObservableFromFetch<FilterData>("RandomTest/GetSavedQuery", params)
}

export function DeleteSavedQuery(filterDataID: number): Observable<number> {
  const params: string = JSON.stringify({
    FilterDataID: filterDataID
  })
  return ObservableFromFetch<number>("RandomTest/DeleteSavedQuery", params)
}
export function SaveQuery(poolCriteria: PoolCriteria): Observable<FilterData> {
  const params: string = JSON.stringify(poolCriteria)
  return ObservableFromFetch<FilterData>("RandomTest/SaveQuery", params)
}
export function SaveQueryAs(poolCriteria: PoolCriteria, name: string): Observable<FilterData> {
  poolCriteria.SaveAs = name;
  poolCriteria.ForceOverride = true;
  poolCriteria.FilterModuleID = FilterDataModule.RandomModule;
  const params: string = JSON.stringify(poolCriteria)
  return ObservableFromFetch<FilterData>("RandomTest/SaveQueryAs", params)
}
